import { computed } from '@vue/composition-api'

import { useAuth } from '@composables/auth'
import { useCurrentUser, useExport } from '@composables'
import { useNavDrawer } from '@composables/useNavDrawer'
import { useReport } from '@composables/report'
import { NAV_MENU, filterMenu, linkMyReports } from '@/config/navMenu'

// The navigation menu as the current user may see it (LIQ-2643) - shared by the menu rail
// (AppNavDrawer) and the home page tiles, so both list the same items for the same roles.
export const useNavMenu = () => {
  const { isUserRole } = useAuth()
  const { hasFCPAccess, canAccessCashCall } = useCurrentUser()
  const { isExportEnabled } = useExport()
  const { state } = useNavDrawer()
  const { encodeReportID } = useReport()

  const context = computed(() => ({
    isSuperuser: isUserRole('Superuser'),
    isCompany: isUserRole('Company'),
    hasFCPAccess: !!hasFCPAccess.value,
    canAccessCashCall: !!canAccessCashCall.value,
    exportEnabled: isExportEnabled.value,
    ...state.hostContext
  }))

  // Report items (Analytics) are linked to the user's My Reports before filtering.
  const menu = computed(() =>
    filterMenu(linkMyReports(NAV_MENU, context.value.myReports, encodeReportID), context.value)
  )

  return { context, menu }
}
